<section class="table-container" tabindex="0" *ngIf="displayedDataLoaded">

    <table mat-table [dataSource]="dataSource">
        <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

        <!-- Columns -->

        <ng-container [sticky]="i === 0" [matColumnDef]="column"
            *ngFor="let column of displayedColumns;let i = index;let last = last">
            <th sticky mat-header-cell *matHeaderCellDef (click)="onColumnClick(i)" [ngClass]="{
                    'active' : (indexSelected + 1 ) === i && state.isDesktop,
                    'cp': i > 0 
                }"> {{column}}
            </th>
            <td (click)="onColumnClick(i)" [ngClass]="{
                'active' : (indexSelected + 1 ) === i && state.isDesktop,
                'cp': i > 0
            }" mat-cell *matCellDef="let element">
                <span *ngIf="column === 'Características'">{{element['Características']}}</span>
                <img *ngIf="column !== 'Características' && showCheckIcon(element,column)" classs="back-icon"
                    src="assets/icons/check-success.svg" alt="">
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="state.isDesktop? displayedColumns: displayedColumnsMobile"></tr>
        <tr mat-row *matRowDef="let row; columns: state.isDesktop? displayedColumns: displayedColumnsMobile;"></tr>
    </table>

</section>